var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalystHeroLines = function SvgAnalystHeroLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460 661"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#97A7BA",
    fillRule: "nonzero",
    d: "M61.667 586a2.667 2.667 0 1 0-5.334 0 2.667 2.667 0 0 0 5.334 0M200 585.5H59v1h141z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#97A7BA",
    d: "M298 470.5c16.292 0 29.5 13.208 29.5 29.5v160.5h-127V500c0-16.292 13.208-29.5 29.5-29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97A7BA",
    fillRule: "nonzero",
    d: "M264 327.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334M264.5 471V325h-1v146z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#97A7BA",
    d: "M310.5 98c0 16.292-13.208 29.5-29.5 29.5H.5V.5H281c16.292 0 29.5 13.208 29.5 29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97A7BA",
    fillRule: "nonzero",
    d: "M453.333 64a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0M310 64.5h146v-1H310z"
  }))));
};
export default SvgAnalystHeroLines;